import { GENERIC_JOURNEY_CONTENT } from '../genericJourneyContent.js';
import { GENERIC_JOURNEY_NARRATIVE_TRANSLATIONS } from './translations.js';

export { GENERIC_JOURNEY_NARRATIVE_TRANSLATIONS };

function normalizeStageMap(stages = {}) {
  return Object.fromEntries(Object.entries(stages).map(([id, value]) => [id, {
    title: value?.[0] || '',
    description: value?.[1] || '',
  }]));
}

function normalizeLinkMap(templateId, commonLinks = {}) {
  const links = GENERIC_JOURNEY_CONTENT[templateId]?.usefulLinks || [];
  return Object.fromEntries(links.map(({ id }) => {
    const value = commonLinks[id] || [];
    return [id, { title: value?.[0] || '', description: value?.[1] || '' }];
  }));
}

export function normalizeGenericJourneyNarrative(templateId, value = {}, commonLinks = {}) {
  return {
    title: value.title || '',
    introduction: value.introduction || '',
    stages: normalizeStageMap(value.stages),
    usefulLinks: normalizeLinkMap(templateId, commonLinks),
    questions: value.questions || [],
  };
}

export function installGenericJourneyNarrativeTranslations(i18n, language) {
  const normalizedLanguage = String(language || '').toLowerCase().split('-')[0];
  const translationPack = GENERIC_JOURNEY_NARRATIVE_TRANSLATIONS[normalizedLanguage];
  if (!translationPack || !i18n?.addResourceBundle) return;

  const { commonLinks = {}, templates = {} } = translationPack;
  const journeys = Object.fromEntries(
    Object.entries(templates).map(([templateId, value]) => [
      `generic-${templateId}`,
      normalizeGenericJourneyNarrative(templateId, value, commonLinks),
    ]),
  );

  i18n.addResourceBundle(normalizedLanguage, 'hospitalJourney', { journeys }, true, true);
}
